import MainImg from "assets/images/4.jpeg";
import CoalImage from "assets/images/coal.png";
import CopperImage from "assets/images/copper.png";
import GoldImage from "assets/images/gold.png";
import Energy from "assets/images/Energy.png";
import gypsum from "assets/images/gemstoneClassification.png";
import Dimension from "assets/images/Dimension.png";
import Industrial from "assets/images/Industrial.png";
import Metallic from "assets/images/Metallic.png";
import DimensionIcon from "assets/images/DimensionIcon.png";
import DiamondIcon from "assets/images/DiamondIcon.png";
import EnergyIcon from "assets/images/EnergyIcon.png";
import IndustrialIcon from "assets/images/IndustrialIcon.png";
import MetallicIcon from "assets/images/MetallicIcon.png";
import brightIcon from "assets/images/brightIcon.svg";
import dimensionStoneIcon from "assets/images/dimensionStone.svg";
import copperGoldIcon from "assets/images/copperGoldIcon.svg";
import rockSaltIcon from "assets/images/rockSalt.svg";
import limestoneIcon from "assets/images/limestoneIcon.svg";
import ironOreIcon from "assets/images/ironOreIcon.svg";
import gypsumIcon from "assets/images/gypsumIcon.svg";
import gemStoneIcon from "assets/images/gemStoneIcon.svg";
import coalIcon from "assets/images/coalIcon.svg";
import brightGreen from "assets/images/brightGreen.svg";
import copperSlider from "assets/images/copperSlide.png";
import goldSlider from "assets/images/goldSlider.png";
import chromiteSlider from "assets/images/chromiteSlider.png";
import coalSlider from "assets/images/coalSlider.png";
import saltSlider from "assets/images/saltSlider.png";
import ironSlider from "assets/images/ironSlider.png";
import limeSlider from "assets/images/limeSlider.png";
import marbelSlider from "assets/images/marbelSlider.png";
import BriteSlider from "assets/images/BriteSlider.png";
import gemstonesSlider from "assets/images/gemstonesSlider.png";
import gypsumSlider from "assets/images/gypsumSlider.png";
import dimensionSlider from "assets/images/dimensionStone.png";
import chemical from "assets/images/chamical.png";
import construction from "assets/images/construction.png";
import glass from "assets/images/glass.png";
import oil from "assets/images/oil.png";
import food from "assets/images/foodindustry.png";
import spa from "assets/images/spa.png";
import pharma from "assets/images/pharma.png";
import aerospace from "assets/images/aerospace.png";
import steel from "assets/images/steel.png";
import refractory from "assets/images/refractory.png";
import leather from "assets/images/leather.png";
import limesteel from "assets/images/limesteel.png";
import limemachinery from "assets/images/machinery.png";
import limeinfrastructure from "assets/images/infrastructure.png";
import limeindustrilization from "assets/images/industrilization.png";
import cement from "assets/images/cement.png";
import agriculture from "assets/images/agriculture.png";
import plaster from "assets/images/plaster.png";
import fertilizer from "assets/images/fertilizer.png";
import environment from "assets/images/environment.png";
import ironagriculture from "assets/images/ironagricultue.png";
import ironcement from "assets/images/ironcement.png";
import ironconstruction from "assets/images/ironconstruction.png";
import electricity from "assets/images/electricity.png";
import coalcement from "assets/images/coalcement.png";
import coalchemical from "assets/images/coalchemical.png";
import brick from "assets/images/brick.png";
import jewelry from "assets/images/jewelry.png";
import fashion from "assets/images/fashion.png";
import healings from "assets/images/healings.png";
import electrical from "assets/images/electrical.png";
import automotive from "assets/images/automotive.png";
import goldjewelry from "assets/images/goldjewelry.png";
import goldtrade from "assets/images/goldtrade.png";
import collectibles from "assets/images/collectibles.png";
import dimensionconstruction from "assets/images/dimensionconstruction.png";
import monument from "assets/images/monument.png";
import decor from "assets/images/decor.png";
import landscaping from "assets/images/landscaping.png";
import rockSaltWhite from "assets/images/rockSaltWhite.svg";
import chromiteWhite from "assets/images/chromiteWhite.svg";
import dimenstionStoneWhite from "assets/images/dimenstionStoneWhite.svg";
import copperGoldWhite from "assets/images/copperGoldWhite.svg";
import gemStoneWhite from "assets/images/gemStoneWhite.svg";
import coalWhite from "assets/images/coalWhite.svg";
import ironOreWhite from "assets/images/ironOreWhite.svg";
import gypsumWhite from "assets/images/gypsumWhite.svg";
import limestoneWhite from "assets/images/limestoneWhite.svg";

export const homeSlider = {
  first: {
    title: "About us",
    description: `The Pakistan Minerals Information and Services Portal dubbed as PAKISTAN MINES is envisioned to be a gateway for investors, professionals, academics and government officials for economic prosperity. 
              MINES aims to enhance and enrich the potential of Pakistan's mineral and mining industry. With a focus on consolidating critical information for the sector, the objective is to attract investment and foster international interest from companies seeking promising exploration prospects within Pakistan`,
    image: MainImg,
    location:
      "Boya Copper Mines, North Waziristan District, Khyber Pakhtunkhwa",
  },
  sec: {
    title: "Objectives",
    description: `This portal aims to augment existing national efforts to uplift the minerals & mining industry of Pakistan, It will serve as a gateway to mining value chain for investors, academics, regulators & general public, in order to attract local and foreign investment & interest.`,
    image: "/VisionMine.png",
    location: "Khewra Salt Mines, Jhelum District, Punjab",
  },
  thr: {
    title: "Vision",
    description: `The Portal aims to be a comprehensive platform embodying the interests of Pakistan’s minerals & mining sector, that will contribute to a brighter future for Pakistan’s mineral development within global context.`,
    image: "/RectangleOne.png",
    location: "Thar Sino Block I, Tharparkar, Sindh",
  },
};
export const mineralPotential = {
  first: {
    title: "01",
    description: `Pakistan has world's 5th biggest gold mine, with huge reserves in Balochistan. The Reko Diq field project is a testament to the lucrative gold potential in Pakistan.`,
    image: GoldImage,
  },
  sec: {
    title: "02",
    description: `With the world's 5th biggest copper mine, Pakistan has one of the largest under-developed copper deposits in the world. The Reko Diq & Saindak projects make Pakistan a noteworthy player in the global copper market.`,
    image: CopperImage,
  },
  thr: {
    title: "03",
    description: `Pakistan has significant coal reserves, primarily found in the Thar Desert region. The Thar coalfield is one of the largest lignite coalfields in the world, offering potential for energy production and industrial development.`,
    image: CoalImage,
  },
};
export const mineralPotential2 = [
  {
    title: "Gold",
    shortDiscription: "",
    production: "",
    location: "Chagai Magmatic Arc, Lasbella – Khuzdat Belt",
    project: " Saindak, Reko Diq",

    discription: "",

    Img: goldSlider,
  },
  {
    title: "Chromite",
    shortDiscription: "Leading producer",
    production: "Production 2022-2023: ",
    amount: "  158,874 tons",
    location: "Chagai Magmatic Arc, Lasbella Khuzdar Belt",
    project: "",

    discription: "",

    Img: chromiteSlider,
  },
  {
    title: "Copper",
    shortDiscription: "One of the largest reserves",
    production: "Production 2022-2023:",
    amount: " 13378 tons",
    location: "Chagai Magmatic Arc, Lasbella – Khuzdat Belt",
    project: " Saindak, Reko Diq, Boya Muhammad Khel",

    discription: "",

    Img: copperSlider,
  },
  {
    title: "Coal",
    shortDiscription: "Largest reserves at a single place",
    production: "Production 2022-2023:",
    amount: " 14,968,040 tons",
    location: "Tharparkar, Lakhra",
    project: " Sino Sindh Thar Coal Block I  Sindh Engro Thar Block II",

    discription: "",

    Img: coalSlider,
  },
  {
    title: "Rock salt",
    shortDiscription: "2nd largest",
    production: "Productions 2022- 2023: ",
    amount: " 2,915,724 tons",
    location: "Khewra, Warcha",
    project: " Punjab Mineral Company Pvt Ltd",

    discription: "",

    Img: saltSlider,
  },
  {
    title: "Iron Ore",
    shortDiscription: "250 M tons",
    production: "Production 2022 - 2023:",
    amount: " 376,970 tons",
    location: "Chagai Magmatic Arc, Chiniot, Kalabagh",
    project: " Punjab Mineral Company Pvt Ltd",

    discription: "",

    Img: ironSlider,
  },
  {
    title: "Limestone",
    shortDiscription: "",
    production: "Production 2022-2023:",
    amount: " 60,590,496",
    location: "Harnai, Nowshera",
    project: "",

    discription: "",

    Img: limeSlider,
  },
  {
    title: "Marble",
    shortDiscription: "",
    production: "Production 2020-2022: ",
    amount: "7,922,155",
    location: "Lasbella – Khuzdar Belt, Loralai",
    project: "",

    discription: "",

    Img: marbelSlider,
  },
  {
    title: "Barite",
    shortDiscription: "69 million Metric ton",
    production: "Production 2022-2023: ",
    amount: "139,655 tons",
    location: "",
    project: " Saindak, Reko Diq",

    discription: "",

    Img: BriteSlider,
  },
  {
    title: "Gemstones",
    shortDiscription: "Diverse variety",
    production: "",
    location: "Gilgit-Baltistan",
    project: "",

    discription: "",

    Img: gemstonesSlider,
  },
  {
    title: "Gypsum",
    shortDiscription: "",
    production: "Production 2022- 2023: ",
    amount: " 1,638,724 tons",
    location: " Karak, Dera Ismail Khan",
    project: "",

    discription: "",

    Img: gypsumSlider,
  },
];
export const mineralClassification = [
  {
    title: "Metallic Minerals",
    description:
      "With the 5th biggest copper & gold mine in the world, Pakistan estimates the annual profit from these mines to be $3.64 billion. With belts of chromite deposits in Balochistan & KPK, Pakistan boasts an estimated reserve of 2.5 million tons, while the Chagai Iron Ore deposits are being produced at 24,000 tons per annum.",
    avatar: Metallic,
    icon: MetallicIcon,
  },
  {
    title: "Dimension Stones",
    description:
      "The country boasts a significant presence of dimension stones such as granite, marble, limestone, sandstone, and slate, with varying colors, textures, and patterns. These dimension stones are found in different regions, including the famous marble quarries in Balochistan, Khyber Pakhtunkhwa, and Punjab provinces. ",
    avatar: Dimension,
    icon: DimensionIcon,
  },
  {
    title: "Gemstones",
    description:
      "The mines in Pakistan boast world’s finest quality Aquamarine, emeralds and pink topaz. From the rugged peaks of the Gilgit-Baltistan region to the remote valleys of Khyber Pakhtunkhwa, these mining sites have captivated gemstone enthusiasts, collectors, and geologists alike.",
    avatar: gypsum,
    icon: DiamondIcon,
  },
  {
    title: "Industrial Minerals ",
    description:
      "Pakistan is home to a diverse array of industrial minerals, including limestone, gypsum, salt, and quartzite, among others. These industrial minerals are found in various regions across the country, with significant deposits in areas such as Punjab, Sindh, Khyber Pakhtunkhwa, and Balochistan, making Pakistan a key supplier of raw material for industrial processess.",
    avatar: Industrial,
    icon: IndustrialIcon,
  },
  {
    title: "Energy",
    description:
      "With the world’s 5th largest coal mine, Pakistan produces 9 million tons of coal every year. This coal is used for power generation in various industries. Moreover, with extensive reserves of 297 billion tons of marble, there are more than 40 types of natural colored marbles.",
    avatar: Energy,
    icon: EnergyIcon,
  },
];
export const mineralWealth = [
  {
    title: "Barite",
    location: "Balochistan",
    reserve: "14M tons",
    production: "2022-2023: 139,655 tons",
    gml: " $15.09M",
    avatar: BriteSlider,
    tagFirst: "Chemical",
    secTag: "Construction",
    thrTag: "Ceramics & Glass",
    frTag: "Oil & Gas",
    icon: brightIcon,
    iconGreen: brightGreen,
    footerImgFirst: chemical,
    footerImageSec: construction,
    footerImageThr: glass,
    footerImageOil: oil,
    description:
      "Pakistan has abundant deposits of barite – a high-gravity mineral used in the production of multiple industrial products. The Barite deposits are located in the metallogenic zone of 300km long Lasbela-Khuzdar Belt in Balochistan. Bolan Mining Enterprises, a joint venture of the Government of Balochistan and Pakistan Petroleum Ltd (PPL), has a barite mine lease spread over 316 acres in Gunga (Khuzdar), operating a grinding/milling plant with a daily average production of 800-1000 tons (BME/PPL). Its industrial and commercial applications makes it an important industry mineral, especially in the oil and gas sector. The high-quality barite from Khuzdar is highly demanded in the international markets, including China, Iran & UAE (PPM Solutions). Daily production figures are averaged for 9 months from July 2021 to March 2022",
  },
  {
    title: "Rock Salt",
    location: "Khewra Mine",
    reserve: " 65 Million tons",
    production: " 2022-2023: 2,915,724 tons",
    gml: " $12.65B",
    avatar: saltSlider,
    tagFirst: "Food Industry",
    secTag: "Chemical",
    thrTag: "Spa & Beauty",
    frTag: "Paramaceutical",
    icon: rockSaltWhite,
    iconGreen: rockSaltIcon,
    footerImgFirst: food,
    footerImageSec: chemical,
    footerImageThr: spa,
    footerImageOil: pharma,
    description:
      "Pakistan boasts the world's 2nd largest reserves of Rock Salt (SIFC). The rock salt deposits are estimated to be over 65 million metric tons (PMDC), including reserves of both pink salt in Salt Range region and grey salt in Kohat Saline Series. Pakistan is one of the few countries that are bestowed with all three sources of rock salt including salt mines, saline lakes and sea salt. Khewra Salt mines are the world’s oldest and 2nd largest, producing 450,000 tons of salt annually (TDAP, 2021). Warcha Salt mines produce white crystalline salt while Bahadur Khel & Jatta Salt mines produce light gray to dark gray salt. There is a growing demand of salt products in the western countries & Pakistan’s salt products are known all over the world for their distinctive composition and craftsmanship. Growing international demand for salt products, availability of cheap and skilled labor, coupled with abundant raw material provides a lucrative offer & promising opportunity to investors to venture into salt products manufacturing. ",
  },
  {
    title: "Chromite",
    location: "Balochistan",
    reserve: " 4.5 million tons",
    production: " 2022-2023: 158,874 tons",
    gml: "$7618.4 M",
    avatar: chromiteSlider,
    tagFirst: "Aerospace & Defence",
    secTag: "Stainless Steel",
    thrTag: "Refractory",
    frTag: "Leather",
    icon: chromiteWhite,
    iconGreen: brightGreen,
    footerImgFirst: aerospace,
    footerImageSec: steel,
    footerImageThr: refractory,
    footerImageOil: leather,
    description:
      "Pakistan possess a significant amount of chromite ore, with estimated reserves of 4.5 million tons. These reserves have a 115,000 metric tons potential to be extracted annually (Finance, 2021). The chromite market has a $2 billion global demand. Bostan & Lasbela Special Economic Zones are effective locations for setting up ferrochrome production plant due to their proximity  to chromite-producing districts of Muslim Bagh, Khanozai, Nasai, Wadh and Khuzdar. This location will also have the advantage of being close to CPEC routes, giving it easy access for transportation to various steel industries in the country, as well as for foreign imports.",
  },
  {
    title: "Dimension Stone",
    location: "KPK, Sindh",
    reserve: "297 billion tons",
    production: "2022-2023: 6,347,138 tons",
    gml: "$13.4B",
    avatar: dimensionSlider,
    tagFirst: "Construction",
    secTag: "Monument & Sculpture",
    thrTag: "Interior Design & Decor",
    frTag: "Landscaping",
    icon: dimenstionStoneWhite,
    iconGreen: dimensionStoneIcon,
    footerImgFirst: dimensionconstruction,
    footerImageSec: monument,
    footerImageThr: decor,
    footerImageOil: landscaping,
    description:
      "Pakistan has been endowed with extensive reserves of 297 billion tons of marble & granite (TDAP). More than 40 types of natural-colored marbles spread through 4 provinces of Pakistan. Pakistan Stone Development Company (PASDEC) and subsidiary of Pakistan Industrial Development Corporation, has initiated many projects to uplift the existing set up of Marble and granite sector. These projects are setup according to international practices, employ modern technology and focus on detail technical studies .As per plane about 10 model quarries and a number of marble cities are to be created in Pakistan .According to (PESDEC) estimates about 96,000 new jobs are to be created .these projects hold the promise to transform Pakistan’s dimension sector to a great extent.",
  },
  {
    title: "Copper & Gold",
    location: "Balochistan",
    reserve: "4.5 billion tons",
    production: "2022-2023: 13378 tons",
    gml: "$169B",
    avatar: goldSlider,
    tagFirst: "Electrical & Electronics",
    secTag: "Automotive",
    thrTag: "Jewelry",
    frTag: "Commodity Trading ",
    icon: copperGoldWhite,
    iconGreen: copperGoldIcon,
    footerImgFirst: electrical,
    footerImageSec: automotive,
    footerImageThr: goldjewelry,
    footerImageOil: goldtrade,
    description:
      "Pakistan has the world’s 5th largest copper reserves of approximately 4.5 billion tons, mainly concentrated in Balochistan There are opportunities for the private sector and direct foreign investment in the mining, processing, and trading/exports subsectors. Reko Diq is one of the largest undeveloped copper and gold mine globally, having 12.3 million tons of copper & is capable of producing 200,000 tons of copper and 250,000 ounces of gold a year (TDAP). Tethyan Copper Company (TCC) estimates the annual profits from the mines at about $1.14 billion for copper and $2.5 billion for gold, totaling $3.64 billion annually. Copper/Gold production will play a significant part in the global shift to renewable energy and electric vehicles. The International Energy Agency (IEA) has projected that copper demand in the world would double in the coming two decades, i.e., by 2040, while the current demand for copper lies around 28 million tons. Projects like Barrick Reko Diq & Saindak present a compelling opportunity for both domestic and international investors.",
  },
  {
    title: "Gemstones",
    location: "KPK",
    reserve: "34 known types",
    production: "",
    gml: "$32.38M",
    avatar: gemstonesSlider,
    tagFirst: "Jewelry",
    secTag: "Fashion & Accessories",
    thrTag: "Healing & Wellness",
    frTag: "Collectibles & Investment",
    icon: gemStoneWhite,
    iconGreen: gemStoneIcon,
    footerImgFirst: jewelry,
    footerImageSec: fashion,
    footerImageThr: healings,
    footerImageOil: collectibles,
    description:
      "Pakistan has been endowed with extensive reserves of rare gemstones such as pink topaz. It produces world’s top-quality emeralds, aquamarine, tourmaline, rubies, quartz, topaz, garnet and variety of other gemstones. More than 34 types of gemstones are being produced in Gilgit Baltistan. Swat emerald is famous in world for its top quality, color and luster. Pakistan’s gemstone mining sector hold considerable promise, offering opportunities for exploration, investment and growth. With its rich geological heritage and supportive government policies, Pakistan is well positioned to emerge as a significant player in the global gemstone market in the years to come. The major gemstone and mineral specimen mines of Pakistan are found in five regions of the far north, home to K2, the second tallest mountain in the world. They include NWFP-North West Frontier Province bordering Afghanistan, Gilgit and Skardu bordering China, AJK. The Katlang mine, renowned for its sweet baby pink and purplish pink topaz is in Mardan district between Peshawar and Swat in NWFT. The Nangimali, Batakundi and Basil ruby and sapphire mines are in Azad & Jammu Kashmir. Throughout Skardu, Shigar, Hunza and Gilgit in the Gilgit–Baltistan region in Pakistan’s side of Kashmir, hundreds of small mines produce quartz, topaz, aquamarine, ruby, tourmaline, peridot.",
  },
  {
    title: "Coal",
    location: "Sindh",
    reserve: "186 billion tons",
    production: "2022-2023: 9M",
    gml: "2.5T",
    avatar: coalSlider,
    tagFirst: "Electricity Generation",
    secTag: "Cement",
    thrTag: "Brick Knills",
    frTag: "Chemical",
    icon: coalWhite,
    iconGreen: coalIcon,
    footerImgFirst: electricity,
    footerImageSec: coalcement,
    footerImageThr: brick,
    footerImageOil: coalchemical,
    description:
      "Pakistan is blessed with abundant coal reserves for both energy and fuel, concentrating in the region of Tharparkar, Sindh. The total coal reserves are 185 billion tons, covering an area of 9100 square kilometers, which places Pakistan at the hub of coal investment. If properly exploited, Pakistan’s coal resources may generate more than 100,000 MW of electricity for the next 30 years. ",
  },
  {
    title: "IRON ORE",
    location: "",
    reserve: "267 Million tons",
    production: "2022- 2023: 376,970 tons",
    gml: "",
    avatar: ironSlider,
    tagFirst: "Agriculture",
    secTag: "Cement",
    thrTag: "Construction",
    frTag: "Environment",
    icon: ironOreWhite,
    iconGreen: ironOreIcon,
    footerImgFirst: ironagriculture,
    footerImageSec: ironcement,
    footerImageThr: ironconstruction,
    footerImageOil: environment,
    description:
      "Pakistan possesses significant potential in the mining of iron ore, offering lucrative opportunities for investors seeking to capitalize on this untapped resource. The country's geological surveys and exploratory efforts have revealed substantial reserves of high-quality iron ore across various regions, concentrated mainly in Karak & Dera Ismail Khan, Khyber Pakhtunkhwa. The demand for iron ore globally remains robust, driven by the ongoing industrialization and infrastructure development in emerging economies. Investing in Pakistan's iron ore mining sector aligns with sustainability goals and responsible resource management. The Iron Ore concentration is located at the southern edge of Chiniot Town and 35 Km north of Faisalabad city in central part of Punjab. Work on Chiniot iron resource is being carried out in collaboration with renowned international companies to develop its potential. Moreover, Special Economic Zone in Chiniot is also under consideration. Pakistan's iron ore reserves offer opportunities for establishing downstream industries such as steel production, beneficiation plants, and manufacturing of iron-based products. This integrated approach not only adds value to the raw material but also creates employment, fosters economic diversification, and contributes to the country's industrial growth and self-sufficiency goals.",
  },
  {
    title: "Gypsum",
    location: "",
    reserve: "4.8 billion tons",
    production: "2022- 2023: 1,638,724 tons",
    gml: "",
    avatar: gypsumSlider,
    tagFirst: "Cement",
    secTag: "Agriculture",
    thrTag: "Plaster",
    frTag: "Fertilizer",
    icon: gypsumWhite,
    iconGreen: gypsumIcon,
    footerImgFirst: cement,
    footerImageSec: agriculture,
    footerImageThr: plaster,
    footerImageOil: fertilizer,
    description:
      "Pakistan boasts significant gypsum reserves, primarily located in Punjab, Balochistan, and Khyber Pakhtunkhwa. Gypsum is a versatile mineral essential in various industries, including construction, cement, and agriculture. Despite its vast reserves, Pakistan has yet to fully capitalize on its gypsum potential, even as global demand continues to rise. Gypsum plays a critical role in the cement industry, which is experiencing robust growth due to the nation’s expanding infrastructure projects. It is also crucial in agriculture, where it improves soil structure and fertility, leading to better crop yields. Additionally, gypsum is used in the production of plaster, drywall, fertilizers, and soil conditioners, further highlighting its economic importance. The global shift towards greener and more sustainable products has propelled gypsum into the spotlight, presenting Pakistan with a prime opportunity to expand its market presence both domestically and internationally. Despite favorable trade relations with countries such as China and Qatar, Pakistan’s gypsum exports remain underdeveloped compared to its potential. To unlock this potential, Pakistan needs to modernize its mining techniques, improve practices, and establish efficient processing units near quarries. These steps will enhance productivity, reduce costs, and minimize environmental impact. Investing in the gypsum sector promises substantial returns, driving economic growth and contributing to industrial diversification and stability. With the right strategies, Pakistan can become a competitive player in the global gypsum market, fostering sustainable development.",
  },
  {
    title: "LIMESTONE",
    location: "",
    reserve: " Sufficient Reserves",
    production: "2022- 2023: 60,590,496 ",
    gml: "",
    avatar: limeSlider,
    tagFirst: "Stainless Steel",
    secTag: "Machinery",
    thrTag: "Infrastructure",
    frTag: "Industrilization",
    icon: limestoneWhite,
    iconGreen: limestoneIcon,
    footerImgFirst: limesteel,
    footerImageSec: limemachinery,
    footerImageThr: limeinfrastructure,
    footerImageOil: limeindustrilization,
    description:
      "Pakistan is rich in limestone reserves, with extensive deposits found in regions such as Punjab, Khyber Pakhtunkhwa, Balochistan, and Sindh. These reserves showcase significant mineral potential with diverse applications across industries such as cement, construction, agriculture, industry, environment, and exports. Investing in limestone mining and value-added processing ventures in Pakistan presents opportunities for investors to leverage the country's mineral wealth, contribute to economic development, foster industrial growth, and meet market demands domestically and internationally. Limestone is a primary raw material in the cement industry, and Pakistan's cement sector is a major consumer of limestone. The country's growing construction and infrastructure development projects drive demand for cement, creating a significant market for limestone extraction and processing. Limestone&#39;s chemical and physical properties makes it suitable for various industrial applications, including steel production, sugar refining, glass manufacturing, paper production, water treatment, and chemical processing. Pakistan's industrial sector relies on limestone for diverse processes and products. Pakistan's limestone sector offers export opportunities for limestone-derived products to regional and international markets. The country's strategic location, competitive pricing, and quality standards make Pakistani limestone products attractive for export-oriented businesses.",
  },
];

export const registerOrganizationOption = [
  // {
  //   value: "GovernmentDepartments",
  //   label: "Government Departments",
  // },
  // {
  //   value: "MiningProfessionals",
  //   label: "Mining Professionals",
  // },
  {
    value: "GeotechnicalGeophysicalGeologicalServices",
    label: "Geotechnical, Geophysical & Geological Services",
  },
  {
    value: "DrillingCompanies",
    label: "Drilling Companies",
  },
  {
    value: "MiningCompanies",
    label: "Mining Companies",
  },
  {
    value: "MineralBasedIndustries",
    label: "Mineral based industries",
  },
  {
    value: "MachinerySuppliers",
    label: "Machinery suppliers",
  },
  {
    value: "MineralTestingLabs",
    label: "Mineral Testing Labs",
  },
  {
    value: "ExplosiveSuppliers",
    label: "Explosive Suppliers",
  },
  {
    value: "SoftwareandSolutionsEntities",
    label: "Software and Solutions Entities",
  },
  {
    value: "LegalServices",
    label: "Legal Services",
  },
  {
    value: "AuditAccounts",
    label: "Audit & Accounts",
  },
  {
    value: "LandSurveying",
    label: "Land Surveying",
  },
  {
    value: "AcademiaAndRD",
    label: "Academia",
  },
  {
    value: "TrainingSchools",
    label: "Training Schools",
  },
  {
    value: "OtherServices",
    label: "Other Services",
  },
];

export const whoIsWhoCards = [
  {
    title: "Government Departments",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/government-departments",
  },
  {
    title: "Mining Professional",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/mining-professional",
  },
  {
    title: "Geotechnical, Geophysical & Geological Services",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/geotechnical-geophysical-services",
  },
  {
    title: "Drilling Companies",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/drilling-companies",
  },
  {
    title: "Mining Companies",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/mining-companies",
  },
  {
    title: "Mineral Based Industries",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/mineral-based-industries",
  },
  {
    title: "Machinery suppliers",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/machinery-suppliers",
  },
  {
    title: "Mineral Testing Labs",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/mineral-labs",
  },
  {
    title: "Explosive Suppliers",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/explosive-suppliers",
  },
  {
    title: "Software and Solutions Entities",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/software-solution-entities",
  },
  {
    title: "Legal Services",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/legal-services",
  },
  {
    title: "Audit & Accounts",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/audit-accounts",
  },
  {
    title: "Land Surveying",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/land-surveying",
  },
  {
    title: "Academia And RD",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/academia",
  },
  {
    title: "Training Schools",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/training-schools",
  },
  {
    title: "Other Services",
    flipContent:
      "   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam eget felis ut lorem ultricies .",
    link: "/other-services",
  },
];
